import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function Card({ width, size, colour, type, hasReadMore, noLink, link, imageRight, className, data, children }) {
  useEffect(() => {
    if (typeof window.initialiseCard === 'function') {
      window.initialiseCard();
    }
  }, []);

  const cardClasses = classNames('card', 'js-card', className, {
    ['card--' + width]: width,
    ['card--' + size]: size,
    ['card--' + colour]: colour,
    ['card--style-' + type]: type,
    'card--has-read-more': hasReadMore,
    'card--no-link': noLink || link === false,
    'card--image-right': imageRight
  });

  return (
    <article className={cardClasses} {...data}>
      {children}
    </article>
  );
}

Card.propTypes = {
  /**
   * The width of the card
   */
  width: PropTypes.oneOf(['25', '33', '50', '66', '75', '100']),
  /**
   * The size of the card
   */
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  /**
   * The colour of the card
   */
  colour: PropTypes.oneOf([
    'gel-white',
    'gel-grey',
    'brand-light-green',
    'brand-dark-green',
    'brand-pink',
    'brand-purple',
    'brand-navy',
    'brand-plum',
    'brand-aqua',
    'brand-orange',
    'brand-a',
    'brand-b',
    'brand-c',
    'brand-d',
    'brand-e',
    'brand-f'
  ]),
  /**
   * The type of the card
   */
  type: PropTypes.oneOf([
    'card',
    'icon',
    'related',
    'stacked',
    'infographic',
    'cta',
    'tabbed',
    'scale',
    'stat',
    'content',
    'industry',
    'industry-data',
    'grid'
  ]),
  hasReadMore: PropTypes.bool,
  noLink: PropTypes.bool,
  link: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  imageRight: PropTypes.bool,
  className: PropTypes.arrayOf(PropTypes.string),
  data: PropTypes.object,
  /**
   * The nested children
   */
  children: PropTypes.node.isRequired
};

export default Card;
